import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=6fc2936c&scoped=true&"
import script from "./ArrowButton.vue?vue&type=script&lang=ts&"
export * from "./ArrowButton.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowButton.vue?vue&type=style&index=0&id=6fc2936c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc2936c",
  null
  
)

export default component.exports